import React, { useContext } from 'react';
import { Row, Col, Divider, Form, Input, Button, Space, Card, message, Spin } from 'antd';
import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';
import { loadAuth2 } from 'gapi-script';
import { UserContext } from '../Reducers/UserContext';
import { useSecureConfigContext } from '../SecureConfig/SecureConfigProvider';
import { authorizeData, authorizeGoogle } from '../../api';
import Auth0Login from '../Auth0Login/Auth0Login';

// const envs = require("../../env.json");

const env = process.env.REACT_APP_ENV_MODE;

const SalesforceLogin = () => {
    const { isLoggedIn, setLogger } = useContext(UserContext);
    const { getGoogleClientId, hasSecureConfig, loading } = useSecureConfigContext();

    const now = new Date();

    // Get Google client ID from secure config only
    const clientId = getGoogleClientId() || '';

    // Check if we should disable login buttons (during config loading or when config unavailable)
    const shouldDisableButtons = loading || !hasSecureConfig();

    // Show warning if no secure config is available
    if (!hasSecureConfig()) {
        console.warn('Secure configuration not available for Google Client ID');
    }

    const containsSpecialChars = (inst) => {
        const specialChars = /[`!#$%^&*()+=\[\]{};':"\\|,<>\/?~]/;
        return specialChars.test(inst);
    };

    // Initialize auth2 only if clientId is available
    let auth2;
    if (clientId) {
        auth2 = loadAuth2(gapi, clientId, '');
    }

    const onSuccess = async (res) => {
        const data = await authorizeGoogle({
            usr: res.profileObj.email,
            res: res.profileObj,
        });

        setLogger({
            active: true,
            user: {
                role: 'guest',
                name: res.profileObj.email,
                subscriber_id: data['usr_exst']['id'],
                entry: now,
                auth0: false,
                auth0LogOut: false,
            },
        });
    };

    const onFailure = (err) => {
        console.log('failed', err);
    };

    const onFinish = async (values) => {
        // console.log('Success:', values);
        if (!containsSpecialChars(values.username)) {
            const data = await authorizeData({
                usr: values.username,
                pwd: values.password,
            });

            // console.log('in sales- ', data);

            data?.access_token &&
            data?.['resp'].includes(values.username) &&
            data?.['usr_exst']['email_id'] === values.username
                ? setLogger({
                      active: true,
                      user: {
                          role: 'guest',
                          name: values.username,
                          subscriber_id: data['usr_exst']['id'],
                          entry: now,
                          auth0: false,
                      },
                  })
                : message.info(`Invalid Credentials`);
        } else {
            message.warning(`Special Chars are not allowed in username`);
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    let rold;

    return (
        <div>
            {!isLoggedIn['active'] ? (
                <div>
                    <br />
                    <Row>
                        <Col span={6}></Col>
                        <Col span={6}>
                            <div style={{ backgroundColor: 'white' }}>
                                <img src="/img/netskope-logo-black.svg" alt="" width="280px" height="52x" />
                            </div>
                        </Col>
                    </Row>
                    <Divider style={{ padding: '0px' }} />
                    <Row>
                        <Col span={9}></Col>
                        <div className="site-card-border-less-wrapper">
                            <Card
                                title="Sign in using Netskope Support credentials"
                                bordered={true}
                                style={{ width: 450, borderRadius: '20px', borderWidth: '8px' }}
                                headStyle={{
                                    backgroundColor: '#F0F8FF',
                                    border: 0,
                                    color: 'grey',
                                }}
                            >
                                <Form
                                    name="basic"
                                    labelCol={{
                                        span: 8,
                                    }}
                                    wrapperCol={{
                                        span: 16,
                                    }}
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}
                                    autoComplete="on"
                                >
                                    <Form.Item
                                        label="Username"
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Input id="username" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Password"
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your password!',
                                            },
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>

                                    <Form.Item
                                        wrapperCol={{
                                            offset: 9,
                                            span: 12,
                                        }}
                                    >
                                        <Space>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                disabled={shouldDisableButtons}
                                                loading={shouldDisableButtons}
                                                style={{
                                                    ...(shouldDisableButtons && {
                                                        backgroundColor: '#1890ff',
                                                        borderColor: '#1890ff',
                                                        color: '#fff',
                                                    }),
                                                }}
                                            >
                                                {shouldDisableButtons ? 'Loading...' : 'Sign In'}
                                            </Button>

                                            <a
                                                href="https://support.netskope.com/s/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Button
                                                    disabled={shouldDisableButtons}
                                                    style={{
                                                        ...(shouldDisableButtons && {
                                                            backgroundColor: '#f5f5f5',
                                                            borderColor: '#d9d9d9',
                                                            color: '#bfbfbf',
                                                        }),
                                                    }}
                                                >
                                                    Sign Up
                                                </Button>
                                            </a>
                                        </Space>
                                    </Form.Item>

                                    <Form.Item
                                        wrapperCol={{
                                            offset: 8,
                                            span: 15,
                                        }}
                                    >
                                        <Auth0Login disabled={shouldDisableButtons} />

                                        {clientId && !shouldDisableButtons ? (
                                            <GoogleLogin
                                                clientId={clientId}
                                                render={(renderProps) => (
                                                    <a onClick={renderProps.onClick}>Netskope Employee? Login here</a>
                                                )}
                                                buttonText="NS Employee Login"
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                                cookiePolicy={'single_host_origin'}
                                                // isSignedIn={true}
                                            />
                                        ) : shouldDisableButtons ? (
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    marginTop: '10px',
                                                }}
                                            >
                                                <Spin size="small" />
                                                <span
                                                    style={{
                                                        marginLeft: '8px',
                                                        color: '#999',
                                                        fontStyle: 'italic',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    🔄 Netskope Employee
                                                </span>
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    color: '#666',
                                                    fontStyle: 'italic',
                                                    fontSize: '12px',
                                                    textAlign: 'center',
                                                    marginTop: '10px',
                                                }}
                                            >
                                                Loading...
                                            </div>
                                        )}
                                    </Form.Item>
                                </Form>
                            </Card>
                        </div>
                    </Row>
                </div>
            ) : null}
        </div>
    );
};

export default SalesforceLogin;
